
export function urlify(text, className) {
    const REGEX = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/gm;
    let textArray = text.split(' ');
    return (
        <>
            {textArray.map((word) => {
                return word.match(REGEX)  ?(
                    <>
                        <a href={word} target="_blank" rel="noopener noreferrer" className={className}>{word}</a> {' '}
                    </>
                ) : word + ' '
            })}
        </>
    )
}